<template>
  <b-modal
    :id="modalId"
    :title="modalTitle"
    ok-title="Guardar"
    cancel-title="Cancelar"
    @ok="handleSubmit"
    @hidden="resetForm"
  >
    <b-form @submit.prevent="handleSubmit">
      <b-form-group label="Persona">
        <b-form-select
          v-model="form.personaId"
          :options="personasOptions"
          required
        />
      </b-form-group>
      <b-form-group label="Especialidad" class="mt-1">
        <b-form-input
          v-model="form.especialidad"
          placeholder="Ej: Programación"
          required
        />
      </b-form-group>
      <b-form-group label="Estado" class="mt-1">
        <b-form-select
          v-model="form.estado"
          :options="statusOptions"
          required
        />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { BModal, BForm, BFormGroup, BFormInput, BFormSelect } from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
  },
  props: {
    teacherData: {
      type: Object,
      default: null,
    },
    personas: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      modalId: 'teacher-modal',
      form: {
        catedraticoId: null,
        personaId: null,
        especialidad: '',
        estado: true,
      },
      statusOptions: [
        { text: 'Activo', value: true },
        { text: 'Inactivo', value: false }
      ],
    }
  },
  computed: {
    modalTitle() {
      return this.form.catedraticoId ? 'Editar Docente' : 'Nuevo Docente'
    },
    personasOptions() {
      return this.personas.map(p => ({ 
        value: p.personaId, 
        text: `${p.nombres} ${p.apellidos}` 
      }))
    },
  },
  watch: {
    teacherData(newData) {
      if (newData) {
        this.form = { ...newData }
      } else {
        this.resetForm()
      }
    },
  },
  methods: {
    handleSubmit() {
      this.$emit('submit', { ...this.form })
      this.$bvModal.hide(this.modalId)
    },
    resetForm() {
      this.form = {
        catedraticoId: null,
        personaId: null,
        especialidad: '',
        estado: true,
      }
    },
  },
}
</script>
